export function createDeviceOptions(devices) {
    return devices.map((device) => {
        return {
            value: device.deviceId,
            label: device.label
        };
    });
}
export function closeMenuDelayed(closeFn) {
    setTimeout(() => {
        closeFn(false);
    }, 1);
}
